export default __webpack_public_path__ + "locales/zh-CN/FormFillingTipsDialog.json?hash=dc9cd4b077afab09adfba756e751fae4";